import { colors, strings } from "assets/constants";
import { icons } from "assets/icons";
import {
  _goToAboutUs,
  _goToAddCorp,
  _goToApkVersion,
  _goToAttributes,
  _goToCategories,
  _goToContactUs,
  _goToCorp,
  _goToCorps,
  _goToCountries,
  _goToCustomers,
  _goToFactors,
  _goToNotes,
  _goToOrganization,
  _goToProducts,
  _goToReminders,
  _goToReports,
  _goToTypeOfMeeting,
  _goToUsers,
  _goToWholesalers,
} from "routers/helper";

export const SUPER_ADMIN_SECTIONS = [
  {
    title: "شرکت ها",
    contents: [
      {
        title: "لیست شرکت ها",
        icon: "format-list-checkbox",
        nav: () => _goToCorps(),
      },

      {
        title: "ایجاد شرکت جدید",
        icon: "plus-circle-outline",
        nav: () => _goToAddCorp(),
      },

      {
        title: "ایجاد کشور/استان/شهر جدید",
        icon: "plus-circle-outline",
        nav: () => _goToCountries(),
      },
    ],
  },
  {
    title: "کاربران",
    contents: [
      {
        title: "لیست کاربران",
        icon: "format-list-checkbox",
        nav: () => _goToUsers(),
      },
    ],
  },
  {
    title: "اطلاعات پایه",
    contents: [
      {
        title: "نحوه آشنایی ",
        icon: "google-circles-communities",
        nav: () => _goToTypeOfMeeting(),
      },
      {
        title: "ورژن برنامه",
        icon: "vector-circle-variant",
        nav: () => _goToApkVersion(),
      },
    ],
  },

  {
    title: "سرنخ",
    contents: [
      {
        title: strings.contact_us,
        icon: "phone-outline",
        nav: () => _goToContactUs(),
      },
      {
        title: strings.about_us,
        icon: "information-variant",
        nav: () => _goToAboutUs(),
      },
    ],
  },
];

export const COMPANY_SECTIONS = (
  organization: boolean,
  wholesalers: boolean,
  customers: boolean,
  factors: boolean,
  reminders: boolean,
  notes: boolean,
  attributes: boolean,
  categories: boolean,
  products: boolean,
  friendShip: boolean,
  report: boolean
) => {
  return [
    {
      title: strings.organization,
      icon: icons._organization,
      iconSize: 20,
      nav: () => _goToOrganization(),
      perm: organization,
    },

    {
      title: strings.wholesalers,
      icon: icons._customers,
      nav: () => _goToWholesalers(),
      perm: wholesalers,
    },

    {
      title: strings.customers,
      icon: icons._customers,
      nav: () => _goToCustomers({}),
      perm: customers,
    },

    {
      title: strings.factors,
      icon: icons._factors,
      nav: () => _goToFactors(),
      perm: factors,
    },

    {
      title: strings.reminders,
      icon: icons._reminders,
      nav: () => _goToReminders(),
      perm: reminders,
    },

    {
      title: strings.notes,
      icon: icons._notes,
      nav: () => _goToNotes(),
      perm: notes,
    },

    {
      title: strings.attributes,
      icon: icons._attributes,
      iconSize: 14,
      nav: () => _goToAttributes(),
      perm: attributes,
    },

    {
      title: strings.categories,
      icon: icons._categories,
      iconSize: 14,
      nav: () => _goToCategories(),
      perm: categories,
    },

    {
      title: strings.products,
      icon: icons._products,
      iconSize: 14,
      nav: () => _goToProducts(),
      perm: products,
    },

    {
      title: strings.familiarity_way,
      icon: icons._hands,
      iconSize: 18,
      nav: () => _goToTypeOfMeeting(),
      perm: friendShip,
      iconColor: colors.dark._13,
    },

    {
      title: strings.reports,
      icon: icons._dot,
      iconSize: 14,
      nav: () => _goToReports(),
      perm: report,
      iconColor: colors.dark._13,
    },

    {
      title: strings.contact_us,
      icon: icons._dot,
      iconSize: 14,
      nav: () => _goToContactUs(),
      perm: true,
      iconColor: colors.dark._13,
    },

    {
      title: strings.about_us,
      icon: icons._dot,
      iconSize: 14,
      nav: () => _goToAboutUs(),
      perm: true,
      iconColor: colors.dark._13,
    },
  ];
};
